import styled from "@emotion/styled"
import { Text, theme } from "@pallet-hq/hegel"
import { VerticallyCenteredRow } from "components/atoms"
import React, { ComponentType } from "react"

type CompanyInfoRowProps = {
    title: string
    icon?: ComponentType<any>
    value: string
    iconStroke?: string
}

export const CompanyInfoRow: React.FC<CompanyInfoRowProps> = props => {
    const Icon = props.icon || (() => <></>)
    return (
        <Row>
            <SpacingDiv>
                <Icon size={18} style={{ stroke: theme.colors.gray600 }} />
            </SpacingDiv>
            <Text variant="paragraphMedium">
                <Text as="span" variant="uiSmall600">
                    {props.title}: &nbsp;
                </Text>
                {props.value}
            </Text>
        </Row>
    )
}

const SpacingDiv = styled.div`
    margin-right: ${theme.space.small};
`
const Row = styled(VerticallyCenteredRow)`
    margin: ${theme.space.xxsmall} 0 0;
`
